import { TemplateNavHeaderStyles } from './NavHeader.styles'
import { getBootstrapIconUrl, BootstrapIcon } from '../Global/icons'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'

const svgPerson = getBootstrapIconUrl(BootstrapIcon.PersonCircle)

const iconTemplate = document.createElement('template')
iconTemplate.innerHTML = `
<wa-icon slot="start" src="${svgPerson}" class="profile-icon"></wa-icon>
`
const t = document.createElement('template')
t.innerHTML = `
  <wa-button
    size="small"
    appearance="plain"
    variant="neutral"
    aria-haspopup="true"
    aria-expanded="false"
    aria-controls="profile-dropdown"
    class="profile-btn"
    with-caret><slot name="buttonText"></slot></wa-button
  >
  <transition name="dropdown-fade">
    <ul class="dropdown-menu mt-1 closed">
      <slot></slot>
    </ul>
  </transition>
`

class NavHeaderUtilityMenu extends HTMLElement {
  private handleOutsideClick: (event: MouseEvent) => void

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    // Bind the handler so it can be removed later
    this.handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  connectedCallback() {
    console.log('NavHeaderUtilityMenu connectedCallback', this)

    const shadow = this.shadowRoot
    if (shadow) {
      const btn = shadow.querySelector('wa-button')
      if (btn) {
        if (this.getAttribute('icon') === 'person-circle') {
          tryLoadDependencies(document, [WebAwesomeComponent.Icon])

          const icon = iconTemplate.content.cloneNode(true)
          btn.prepend(icon)
        }

        btn.addEventListener('click', () => {
          this.toggleMenu()
        })
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('mousedown', this.handleOutsideClick)
  }

  private _handleOutsideClick(event: MouseEvent) {
    // Check if the click is outside the component
    if (!this.contains(event.target as Node)) {
      this.closeMenu()
    }
  }

  private toggleMenu() {
    const panel = this.shadowRoot?.querySelector('ul')
    if (panel) {
      panel.classList.toggle('closed')

      if (!panel.classList.contains('closed')) {
        document.addEventListener('mousedown', this.handleOutsideClick)
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick)
      }
    }
  }

  private closeMenu() {
    const panel = this.shadowRoot?.querySelector('ul')
    if (panel && !panel.classList.contains('closed')) {
      panel.classList.toggle('closed')
    }
  }
}

if (!customElements.get('ts-navheader-utility-menu')) {
  customElements.define('ts-navheader-utility-menu', NavHeaderUtilityMenu)
}
export { NavHeaderUtilityMenu }
